import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  .nutrition-data-loader {
    .ant-spin-text {
      margin-top: 8px;
      color: #2ECF96;
      font-weight: 500;
    }

    .ant-spin-blur {
      opacity: 0.7;
    }
    
    .ant-spin-container {
      transition: all 0.3s ease;
    }
  }
`;

export const MainContainer = styled.div`
  background-color: #e5f5f2;
  border-radius: 20px;
  .main-div {
    background-color: white;
    border-radius: 20px;
    @media screen and (min-width: 768px) {
      height: calc(-100px + 100vh);
    }
    .award-section {
      float: left;
      width: 100%;
    }
  }
`;
export const Container = styled.div`
  margin: 0 auto;
  padding: 16px 20px;
  border-radius: 15px;
`;
export const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  h3 {
    color: #142c1f;
    font-size: 16px;
  }
  p {
    color: #44554c;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const Title = styled.h1`
  color: #3faa7a;
  font-size: 24px;
  margin: 0;
  font-weight: 500;
`;

export const Subtitle = styled.h2`
  color: #333;
  font-size: 20px;
  margin: 8px 0 0;
  font-weight: 500;
`;

export const CoachCard = styled.div`
  display: flex;
  padding: 16px 0 0;

  @media screen and (max-width: 768px) {
    align-items: center;
  }
`;

export const CoachImage = styled.div`
  width: 160px;
  height: 160px;
  overflow: hidden;
  margin-right: 16px;

  @media screen and (max-width: 768px) {
    width: 110px;
    height: 110px;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 15px;
  }
`;

export const CoachInfo = styled.div`
  flex: 1;
`;

export const CoachLabel = styled.p`
  color: #44554c;
  margin: 0;
`;

export const CoachName = styled.h3`
  color: #142c1f;
  font-size: 16px;
  margin: 4px 0;
`;

export const RatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const Stars = styled.div`
  color: #ffcc00;
  font-size: 18px;
`;

export const Reviews = styled.div`
  color: #44554c;
`;

export const DesktopCredentialsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  width: 50%;
  @media screen and (max-width: 768px) {
    display: none;
  }
  /* padding: 16px 0; */
`;
export const MobileCredentialsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (min-width: 768px) {
    display: none;
  }

  /* padding: 16px 0; */
`;

export const CredentialItem = styled.div`
  text-align: left;
  flex: 1;
  border-right: ${(props) => (props.hasBorder ? "3px solid #2ECF96" : "none")};
  padding-left: 4px;
  //fist child
  &:first-child {
    padding-left: 4px;
    padding-right: 10px;
    border-left: 3px solid #2ecf96;
  }
`;

export const CredentialLabel = styled.p`
  color: #44554c;
  font-size: 14px;
`;

export const CredentialValue = styled.p`
  color: #44554c;
  font-weight: 600;
  margin: 0;
`;

export const MessageBox = styled.div`
  background-color: #f2fffa;
  border: 2px solid #2ecf96cc;
  border-radius: 10px;
  padding: 16px;
  margin-top: 20px;
`;

export const MessageTitle = styled.h3`
  color: #142c1f;
  margin: 0 0 6px;
  font-size: 16px;
`;

export const MessageText = styled.p`
  color: #818d88;
  margin: 0;
  line-height: 1.5;
`;

export const InsuranceSection = styled.div`
  margin-top: 14px;
  @media screen and (min-width: 768px) {
    /* display: none; */
  }
`;

export const InsuranceTitle = styled.p`
  color: #142c1f;
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 500;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    /* font-weight: bold; */
  }
`;
export const MobileGrid = styled.div`
  img {
    max-width: 100%;
    height: auto;
  }
  @media screen and (min-width: 768px) {
    display: none;
  }
`;
export const DesktopGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin-bottom: 8px;

  img {
    max-width: 70%;
    height: auto;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const CertificateButton = styled.button`
  background: none;
  border: none;
  color: #46cf96;
  font-size: 12px;
  padding: 8px 0;
  cursor: pointer;
  text-align: center;
  width: 100%;
  font-weight: 500;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;
